import React from "react";

type Props = {
  value: number;
  size?: number;
  stroke?: number;
  className?: string;
  trackClassName?: string;
  indicatorClassName?: string;
  label?: React.ReactNode;
};

export default function ProgressRing({
  value,
  size = 80,
  stroke = 8,
  className = "",
  trackClassName = "stroke-muted",
  indicatorClassName = "stroke-primary",
  label,
}: Props) {
  const clamped = Math.max(0, Math.min(100, value));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (clamped / 100) * circumference;

  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped}
      aria-label={typeof label === 'string' ? label : 'Progress'}
   >
      <svg width={size} height={size} className="rotate-[-90deg]">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          strokeWidth={stroke}
          className={`${trackClassName} opacity-30`}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          strokeWidth={stroke}
          strokeLinecap="round"
          className={indicatorClassName}
          strokeDasharray={`${dash} ${circumference - dash}`}
        />
      </svg>
      <div className="absolute text-sm font-semibold text-foreground select-none">
        {label ?? `${clamped}%`}
      </div>
    </div>
  );
}
